var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHenkel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,25c0-9.5,15.2-17.2,33.8-17.2S93.8,15.5,93.8,25S78.6,42.2,60,42.2S26.2,34.5,26.2,25L26.2,25z M96.3,25 C96.3,14.6,80.1,6.1,60,6.1c-20,0-36.3,8.4-36.3,18.9S39.9,43.9,60,43.9C80,43.9,96.3,35.4,96.3,25L96.3,25z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.4,30.3 32.7,30.3 32.7,19 35.4,19 35.4,23.2 39.6,23.2 39.6,19 42.2,19 42.2,30.3 39.6,30.3  39.6,25.5 35.4,25.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,28c-0.6,2.3-2.8,2.7-4.3,2.7c-1.1,0-4.5-0.2-4.5-4.4c0-2.8,1.9-4.4,4.7-4.4c4,0,4.3,3.5,4.3,4.6V27h-6.4 c0,0.8,0.4,2.2,2,2.2c0.7,0,1.4-0.3,1.7-1H53V28z M50.6,25.4c0-1.8-1.1-2-1.8-2c-0.3,0-1.8,0-2.1,2H50.6L50.6,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.2,23.1c0.6-0.9,1.8-1.3,2.9-1.3s2.8,0.3,2.8,3.4v5.1h-2.5v-4.7c0-0.8-0.1-2.1-1.4-2.1 c-1.6,0-1.7,1.9-1.7,2.2v4.7h-2.5v-8.3h2.4V23.1L57.2,23.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "70.2,22.1 73.3,22.1 70,25.3 73.5,30.3 70.5,30.3 68.2,26.9 67.4,27.7 67.4,30.3 64.9,30.3 64.9,19  67.4,19 67.4,25.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.5,25.4c0.2-2,1.7-2,2.1-2c0.6,0,1.7,0.2,1.8,2H76.5L76.5,25.4z M80.2,28c-0.2,0.7-1,1-1.7,1 c-1.6,0-2-1.4-2-2.2H83v-0.5c0-1-0.2-4.6-4.3-4.6c-2.7,0-4.7,1.5-4.7,4.4c0,4.2,3.4,4.4,4.5,4.4c1.5,0,3.7-0.3,4.3-2.7h-2.6V28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "87.1,19 87.1,30.3 84.6,30.3 84.6,19  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHenkel);
export default __webpack_public_path__ + "static/media/henkel.494a83475a8d157621ebe027cf42a39e.svg";
export { ForwardRef as ReactComponent };